module.exports = __webpack_public_path__ + "img/Frame654ss.e4dfef93.png";